module.exports = __webpack_public_path__ + "img/Laurence Kirk.0d420950.jpg";